module.exports = __webpack_public_path__ + "img/qa.b314986b.svg";